import React from "react"
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TelegramShareButton,
  TelegramIcon
} from 'react-share'
import close from '../assets/images/close.svg'
import Literal from "../literals/Literal"

const ShareModal = ({ url, onClose }) => {

  return (
    <div className="absolute z-20 w-3/4 p-6 bg-white border rounded-xl border-background sm:w-auto">
      <div className="absolute right-0 pr-6 mr-1 cursor-pointer" onClick={onClose}>
        <img src={close} alt="" className="h-4"/>
      </div>
      <div className="p-4">
        <div className="pb-4 text-lg text-center sm:text-xl">{Literal('SHARE_MODAL_TITLE')}</div>
        <div className="flex flex-wrap items-center justify-center w-full sm:justify-around">
          <EmailShareButton
            url={url}
            subject={Literal('SHARE_EMAIL_TITLE')}
            body={Literal('SHARE_QUOTE')}
            className="m-2"
          >
            <EmailIcon size={50} round={true} />
          </EmailShareButton>
          <FacebookShareButton
            url={url}
            quote={Literal('SHARE_QUOTE')}
            className="m-2"
          >
            <FacebookIcon size={50} round={true} />
          </FacebookShareButton>
          <TwitterShareButton
            url={url}
            title={Literal('SHARE_QUOTE')}
            className="m-2"
          >
            <TwitterIcon size={50} round={true} />
          </TwitterShareButton>
          <WhatsappShareButton
            url={url}
            title={Literal('SHARE_QUOTE')}
            className="m-2"
          >
            <WhatsappIcon size={50} round={true} />
          </WhatsappShareButton>
          <TelegramShareButton
            url={url}
            title={Literal('SHARE_QUOTE')}
            className="m-2"
          >
            <TelegramIcon size={50} round={true} />
          </TelegramShareButton>
        </div>
      </div>
    </div>
  )
}

export default ShareModal